import { AnimationTriggerMetadata, animate, state, style, transition, trigger } from '@angular/animations';

export const LeaveFadeOutAnimation: AnimationTriggerMetadata[] = [
	trigger('fadeOutAnimation', [state('void', style({ opacity: 0 })), transition(':leave', animate('0.3s'))])
];
